import React from 'react';
import classNames from 'classnames';

import Grid from '@mui/material/Grid';
import Input from '@mui/material/TextField';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import TranslationIds from '../../../commons/translationIds';

function renderEmail (p) {
    const {
        fields,
        fieldErrors,
        setSubscribersFields,
        classes,
        translate,
        subscribersFields,
        touched,
        statesStore,
    } = p;

    if (!fields || fields.email === 0) {
        return (<React.Fragment></React.Fragment>);
    }
    
    function getLabel () {
        if (fields.email === 1) {
            return `${translate(TranslationIds.REGISTRATION_LABEL_EMAIL)}*`;
        }
        return translate(TranslationIds.REGISTRATION_LABEL_EMAIL);
    }

    function getHelperText () {
        if (touched.email && fieldErrors.email) {
            if (!subscribersFields.email) {
                return translate(TranslationIds.REGISTRATION_REQUIRED_EMAIL);
            }
            return translate(TranslationIds.REGISTRATION_VALID_EMAIL);
        }
        return '';
    }
 
    function inputClass () {
        if (statesStore.autofillFields?.email) {
            return classes.inputBaseAutofill;
        }
        if (fieldErrors.email) {
            return classes.inputBaseError;
        }
        return classes.inputBase;
    }

    return (
        <Grid className={classNames(['ecal-reg-field-email', classes.fieldRoot])}>
            <span className={classNames(['ecal-input-label', classes.fieldLabel])}>
                {getLabel()}
            </span>
            <Input
                id="email"
                name="email"
                className={inputClass()}
                disabled={statesStore.autofillFields?.email}
                InputProps={{
                    classes: {
                        underline: classes.InputUnderline,
                        input: classes.textInput,
                    },

                }}
                // value={subscribersFields.email}

                onBlur={(e) => {
                    setSubscribersFields({
                        email: e.target.value,
                    });
                }}

                onChange={e => {
                    // debounce the changes...
                    setSubscribersFields({
                        email: e.target.value,
                    },
                    {
                        selector: '#email',
                        field: 'email',
                    });
                }}

                margin="normal"
                placeholder={translate(TranslationIds.REGISTRATION_LABEL_EMAIL)}
                type="text"
                fullWidth
                error={ fieldErrors.email }
                helperText={getHelperText()}
            />

            { statesStore.autofillFields?.email && (
                 <CheckCircleIcon
                    className={classes.autofillCheck}
                />
            )}
           
        </Grid>
    );
}

export default renderEmail;